import { addIDForTheList } from '../../generic/utils/addUIDForTheList';
import { handleNotifications } from '../../generic/utils/handleNotifications';
import axios from 'axios';

export const getPallets = async (token, url, setState, setStateDefault) => {
    // Create AbortController instead of CancelToken
    const controller = new AbortController();
    
    try{
        let response = await axios.get(`${url}`, {
            headers: {
                'Authorization' : 'Bearer ' + token
            },
            // Use signal instead of cancelToken
            signal: controller.signal
        });
        
        let concatArr = addIDForTheList(response.data.pallets);
        setState(concatArr);
        setStateDefault(concatArr);
    
    } catch (err) {
        if (!axios.isCancel(err)) {
            handleNotifications('משהו השתבש', {type: "error"});
        }
    }
    
    // Return the controller so it can be used for cleanup if needed
    return controller;
}